import { trackLinkWithData } from '../../lib/analytics/fpti'

export function trackPurchaseProtectionSelection(
  pageData,
  purchaseProtectionSelectionData
) {
  const {
    pageGroup = 'main:p2p:unknown::review:node::',
    pageName = 'main:p2p:unknown::review',
    link = '',
  } = pageData

  var extra

  const {
    changedPurchaseProtection,
    defaultPurchaseProtection,
    currentPurchaseProtection = false,
  } = purchaseProtectionSelectionData

  if (
    changedPurchaseProtection &&
    defaultPurchaseProtection === currentPurchaseProtection
  ) {
    // user changed the default purchase protection, but ultimately went back to the default
    extra = {
      opsel: 'defaultedback',
    }
  } else if (
    changedPurchaseProtection &&
    defaultPurchaseProtection !== currentPurchaseProtection
  ) {
    // user changed the default purchase protection and kept it changed
    extra = {
      opsel: 'changed',
    }
  } else {
    // user never changes the default selection
    extra = {
      opsel: 'default',
    }
  }
  trackLinkWithData(link, pageGroup, pageName, extra, link, {})
}
